import { createContext, type Context } from "react";

export type PortalContextValues = readonly (readonly [Context<unknown>, unknown])[];

export const EMPTY_CONTEXT_VALUES: PortalContextValues = [];
export const PortalContextBridgeScopeContext = createContext<PortalContextValues | null>(null);
